import { render, staticRenderFns } from "./IconRewardTotal.vue?vue&type=template&id=c5d59c34"
import script from "./IconRewardTotal.vue?vue&type=script&lang=js"
export * from "./IconRewardTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports